<template>
    <div class="py-3 w-100 text-center">
        <div class="col-12 d-flex align-items-center gap-3">
            <div :class="['form-check form-switch btn btn-sm btn-outline', {'bg-light-blue border-lighter-blue': model.has_slept}]" role="button" @click="toggleCheckbox">
                <input class="form-check-input" role="button" value="1" name="has_slept" v-model="model.has_slept" type="checkbox">
                <label class="form-check-label" role="button">{{ trans('general.module.report.update_popup.step.details.has_slept') }}</label>
            </div>
        </div>

        <div v-if="model.has_slept" class="d-flex flex-column mt-4 align-items-start text-start">
            <p v-html="trans(`general.daily_reports.nap_period.message`)"></p>
            <basic-time-period v-on:select="selectTimePeriod($event)"/>
        </div>

        <div class="row mt-4" v-if="model.has_slept && addSleepDuration">
            <div class="col-md-6 mt-2 mb-4">
                <div class="bg-gray-100 text-center p-1 fw-bold">
                    {{ trans('general.module.report.update_popup.step.details.fields.from') }}
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <scroll-picker
                        :key="'fromh' + data.value"
                        v-if="hours"
                        :items="hours"
                        @select="hoursFromSelectedOption = $event"
                        :selected="hoursFromSelectedOption">
                    </scroll-picker>

                    <scroll-picker
                        :key="'fromm' + data.value"
                        v-if="minutes"
                        :items="minutes"
                        @select="minutesFromSelectedOption = $event"
                        :selected="minutesFromSelectedOption">
                    </scroll-picker>
                </div>
            </div>
            <div class="col-md-6 mt-2 mb-4">
                <div class="bg-gray-100 text-center p-1 fw-bold">
                    {{ trans('general.module.report.update_popup.step.details.fields.to') }}
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <scroll-picker
                        v-if="hours"
                        :key="'toh' + data.value"
                        :items="hours"
                        @select="hoursToSelectedOption = $event"
                        :selected="hoursToSelectedOption">
                    </scroll-picker>

                    <scroll-picker
                        v-if="minutes"
                        :key="'tom' + data.value"
                        :items="minutes"
                        @select="minutesToSelectedOption = $event"
                        :selected="minutesToSelectedOption">
                    </scroll-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralReportForm from "../GeneralReportForm.vue";
import ScrollPicker from "../../../../theme/molecules/ScrollPicker.vue";
import moment from "moment/moment";
import BasicTimePeriod from "../../../../theme/atoms/BasicTimePeriodSelect.vue";

export default {
    name: "Nap",
    extends: GeneralReportForm,
    components: {BasicTimePeriod, ScrollPicker},
    data() {
        return {
            model: {
                ...this.value,
                has_slept: 0,
                from: null,
                to: null,
            },
            addSleepDuration: false,
            selectedPeriod: null
        };
    },
    watch: {
        model: {
            handler(value) {
                this.internalUpdate = true;
                const newValue = { ...value };

                if (! this.selectedPeriod) {
                    delete newValue.from;
                    delete newValue.to;
                }

                if (!newValue.has_slept) {
                    Object.assign(newValue, { has_slept: 0 });
                } else {
                    Object.assign(newValue, { has_slept: 1 });

                    if (this.addSleepDuration) {
                        newValue.from = this.getFrom();
                        newValue.to = this.getTo();
                    }
                }

                this.$emit('input', newValue);
            },
            deep: true
        },
        addSleepDuration: function (value) {
            if (!value) {
                this.model.from = null;
                this.model.to = null;
            } else {
                this.model.from = this.getFrom();
                this.model.to = this.getTo();
            }
        },
    },
    methods: {
        toggleCheckbox() {
            this.model.has_slept = !this.model.has_slept;

            if (!this.model.has_slept) {
                this.addSleepDuration = false;
                this.selectedPeriod = null;
            }
        },
        getFrom() {
            if (this.addSleepDuration) {
                const from = `${this.hoursFromSelectedOption.value}:${this.minutesFromSelectedOption.value}`;
                return moment(from, 'HH:mm').format('YYYY-MM-DD HH:mm:ss');
            }
            return null;
        },
        getTo() {
            if (this.addSleepDuration) {
                const to = `${this.hoursToSelectedOption.value}:${this.minutesToSelectedOption.value}`;
                return moment(to, 'HH:mm').format('YYYY-MM-DD HH:mm:ss');
            }
            return null;
        },
        selectTimePeriod(event) {
            this.selectedPeriod = event.selected;

            if(event.selected?.value === 'custom') {
                this.addSleepDuration = true;
                return;
            }

            this.addSleepDuration = false;
            this.model.from = event.from;
            this.model.to = event.to;
        }
    },
};
</script>
